import { Fragment } from "react";
import "./DappDevelopment.css";
import { dApp } from "../../staticdata";
import dappdevbanner from "../../assets/images/services/blockchain/dappdevelopment.jpg";


const dAppDevelopment = () => {
  return (
    <Fragment>
      <section className="dapp-style">
        <div className="dapp-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="dapp-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  DApp Development 
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Kairaa, a leading DApps development company, we are
                  committed to delivering innovative, secure, and scalable
                  decentralized applications. With our deep expertise in
                  customized dApp, blockchain technology, and smart contract
                  development, we empower businesses to harness the full
                  potential of decentralized systems. Our team of skilled
                  developers works closely with you to create customized DApps
                  that meet your specific needs, ensuring enhanced transparency,
                  security, and efficiency. Partner with us to transform your
                  ideas into robust decentralized applications and stay ahead.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={dappdevbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="dapp-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">DApp Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {dApp.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="dapp-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default dAppDevelopment;
